import { ScreenSize, SeverityLevel } from './types';

// Alert-related constants

// Truncation limits for different screen sizes
export const TRUNCATION_LIMITS: Record<ScreenSize, { logTypes: number; ruleName: number }> = {
  xs: {
    logTypes: 5,
    ruleName: 15,
  },
  sm: {
    logTypes: 15,
    ruleName: 15,
  },
  md: {
    logTypes: 20,
    ruleName: 30,
  },
  lg: {
    logTypes: 20,
    ruleName: 30,
  },
  xl: {
    logTypes: 20,
    ruleName: 30,
  },
} as const;

// Severity display text mapping
export const SEVERITY_DISPLAY_TEXT_MAP: Record<SeverityLevel, string> = {
  INFO: 'Info',
  LOW: 'Low',
  MEDIUM: 'Med',
  HIGH: 'High',
  CRITICAL: 'Critical',
} as const;

// Quality options for filtering
export const QUALITY_OPTIONS = [
  { value: 'USEFUL', label: 'Useful' },
  { value: 'NOISE', label: 'Noise' },
  { value: '', label: 'Unset' },
] as const;

// AI risk classification prefix and tags used for filtering
export const AI_RISK_TAG_PREFIX = 'ai_risk_';

export const AI_RISK_TAGS = {
  risky: `${AI_RISK_TAG_PREFIX}risky`,
  inconclusive: `${AI_RISK_TAG_PREFIX}inconclusive`,
  benign: `${AI_RISK_TAG_PREFIX}benign`,
} as const;
